import { createContext, useContext } from 'react';
import { ISession } from '../types';

export const SessionContext = createContext(undefined as any);

export const useSession = () => useContext(SessionContext) as ISession;
